'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('flexDirection');


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/flex-direction.js
// module id = 656
// module chunks = 3